import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LayoutDashboard } from "lucide-react";

export default function AdminLogin() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin-login", { email, password });
      loginWithToken(data.token, data.user);
      toast.success("Welcome back, Store Owner!");
      navigate("/admin");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-rose-950 px-4">
      <form onSubmit={submit} className="bg-[#fdfbf7] rounded-2xl p-8 w-full max-w-md fade-up">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-rose-950 text-amber-50 flex items-center justify-center mx-auto"><LayoutDashboard className="w-7 h-7" /></div>
          <h1 className="font-serif text-2xl font-bold text-rose-950 mt-4">Store Owner Dashboard</h1>
          <p className="text-sm text-muted-foreground mt-1">Million Pixels Admin Login</p>
        </div>
        <div className="space-y-4">
          <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" data-testid="admin-email-input" /></div>
          <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12" data-testid="admin-password-input" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-rose-950 hover:bg-rose-900 h-12 rounded-full" data-testid="admin-login-btn">{loading ? "Signing in..." : "Sign In"}</Button>
        </div>
      </form>
    </div>
  );
}
